export enum EnumStatusClienteIdeal{
    IDEAL,
    INTERMEDIARIO,
    NAO_IDEAL,
    NAO_AVALIADO
}